import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { localDateTime } from "../../lib/datetime";

const TONE = {
  credit: "text-success",
  debit: "text-muted-foreground",
  settlement: "text-amber-500",
  grant: "text-primary",
};

export const TxnList = ({ items }) => {
  const { t } = useTranslation();

  return (
    <NeuCard data-testid="wallet-txn-list">
      <p className="label-xs">{t("wallet.ledger")}</p>
      {!items.length ? (
        <p className="mt-4 text-sm text-muted-foreground">{t("wallet.noTxns")}</p>
      ) : (
        <ul className="mt-4 divide-y divide-border/50">
          {items.map((txn) => (
            <li key={txn.id} className="flex items-center justify-between gap-3 py-3" data-testid="wallet-txn-row">
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold">{t(`wallet.kind.${txn.kind}`)}</p>
                <p className="truncate text-xs text-muted-foreground">
                  {localDateTime(txn.at)}
                  {txn.reason ? ` · ${t(`wallet.reason.${txn.reason}`, txn.reason)}` : ""}
                </p>
              </div>
              <div className="shrink-0 text-end">
                <p className={`font-mono text-sm font-bold ${TONE[txn.kind] || "text-foreground"}`}>
                  {txn.tokens > 0 ? "+" : ""}
                  {txn.tokens}
                </p>
                <p className="font-mono text-[11px] text-muted-foreground">{txn.balance_after}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
